import api from '@services'
import { stripEmptyObjects } from '@utils'
const serviceBaseUrl = process.env.REACT_APP_VEHICLE_CRASH_BASE_URL ?? ''
const servicePrefix = `${serviceBaseUrl}/svc/vehicle-crash/api`

const getNcrs = async (params) => {
  const response = await api.get(`${servicePrefix}/ncrs`, { params: stripEmptyObjects(params) })
  console.log(response)
  return response.data
}

const getAllNcrs = async () => {
  const response = await api.get(`${servicePrefix}/ncrs/all`)
  return response.data
}

const addNcrs = async (ncr) => {
  const response = await api.post(`${servicePrefix}/ncrs`, ncr)
  return response.data
}

const updateNcrs = async (ncr) => {
  const { id } = ncr
  const response = await api.patch(`${servicePrefix}/ncrs/${id}`, ncr)
  return response.data
}

const deleteNcrs = async (id) => {
  const response = await api.delete(`${servicePrefix}/ncrs/${id}`)
  return response.data
}

const NcrsMasterService = {
  getNcrs,
  getAllNcrs,
  addNcrs,
  updateNcrs,
  deleteNcrs
}

export default NcrsMasterService
